import React from 'react';
import { GlassCard } from './ui/GlassCard';

export const MenuSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-brand-dark pb-12 animate-pulse">
      {/* Header Skeleton */}
      <div className="relative h-64 w-full bg-brand-surface" />
      
      <div className="mt-16 px-6">
        {/* Nav Skeleton */}
        <div className="flex gap-4 overflow-hidden mb-8">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-10 w-24 bg-brand-surface rounded-full shrink-0" />
          ))}
        </div>

        {/* Categories Skeleton */}
        <div className="space-y-12">
          {[1, 2].map((cat) => (
            <div key={cat} className="space-y-6">
              <div className="h-8 w-48 bg-brand-surface rounded-lg" />
              <div className="grid gap-6">
                {[1, 2, 3].map((item) => (
                  <GlassCard key={item} className="h-32 flex p-4 gap-4 overflow-hidden">
                    <div className="w-24 h-full bg-brand-dark/50 rounded-xl shrink-0" />
                    <div className="flex-1 space-y-3 py-1">
                      <div className="h-5 w-3/4 bg-brand-dark/50 rounded" />
                      <div className="h-4 w-full bg-brand-dark/50 rounded" />
                      <div className="h-5 w-1/4 bg-brand-dark/50 rounded" />
                    </div>
                  </GlassCard>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
